import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { User } from 'new/entities/User';
import { useCurrentOrg } from './useCurrentOrg';

type Options = {
  onlyValid?: boolean;
  orgId?: number;
};

export function useOrgMembers(options?: Options) {
  const { onlyValid, orgId } = options || {};
  const currentOrg = useCurrentOrg();
  const orgMembers = useSelector((s: any) => s.orgs.orgMembers);
  const teamsFromStore = useSelector((s: any) => s.entities.teams);

  const teams = Object.values(teamsFromStore);
  const idOrg = orgId || currentOrg.id;

  return useMemo(() => {
    const orgUsers = orgMembers?.[idOrg]?.membersById || [];

    let users = Object.values(orgUsers).map((user: any) => ({
      ...user,
      name: user.full_name,
    })) as User[];

    if (onlyValid) {
      users = users.filter(
        (user) => user.org_membership_status === 'ACTIVE' && user.user_status === 'ACTIVE',
      );
    }
    return users
      .map((member) => {
        member.teams = [];
        teams.forEach((team: any) => {
          if (team.members.some((tm) => tm.id === member.id)) {
            member.teams.push(team);
          }
        });
        return member;
      })
      .sort(function (a, b) {
        if (a.full_name < b.full_name) {
          return -1;
        }
        if (a.full_name > b.full_name) {
          return 1;
        }
        return 0;
      });
  }, [orgMembers, onlyValid, idOrg, teamsFromStore, orgId]);
}
